import { SectionKicker } from "@/components/marketing/MarketingSection";

export default function MasteringFreeBand() {
  return (
    <section className="px-[6vw] py-[94px] text-white [background:radial-gradient(circle_at_72%_18%,rgba(73,91,255,0.6),transparent_32%),linear-gradient(120deg,#07103a,#1428a8_64%,#5232df)]">
      <div className="mx-auto w-[min(980px,100%)] text-center">
        <SectionKicker className="!text-teal-500">
          Included with Lutely
        </SectionKicker>
        <h2 className="m-0 font-figtree text-[clamp(42px,5vw,67px)] font-black uppercase leading-none tracking-[-0.05em]">
          Master up to 15 tracks a month for free
        </h2>
        <p className="mx-auto mt-[25px] max-w-[790px] font-open-sans text-[19px] leading-[1.65] text-white/[0.78]">
          Preview your masters and use them in your Lutely releases at no cost.
          Subscribers get unlimited mastering. Export a master for just $5, or
          use an export included with your subscription.
        </p>
      </div>
    </section>
  );
}
